const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0
const isLinux = navigator.platform.toUpperCase().indexOf('LINUX') >= 0
const isIOS = /iPhone|iPod/.test(navigator.userAgent)

const textPosition = (font, device) => {
  if ((isLinux || isIOS) && font.family === 'LovileType') {
    return device === 'desktop' ? '5px' : '5px'
  }

  if (isMac) {
    switch (font.family) {
      case 'Beautynigella-Regular':
        return device === 'desktop' ? '4px' : '4px'
      case 'Signatie':
        return device === 'desktop' ? '6px' : '6px'
      case 'Sacramento-Regular':
        return device === 'desktop' ? '4px' : '4px'
      case 'JosefinSlab-Regular':
        return device === 'desktop' ? '1.5px' : '1.5px'
      case 'Xilosa':
        return device === 'desktop' ? '4px' : '4px'
      case 'Alice':
        return device === 'desktop' ? '-2px' : '-2px'
      case 'LovileType':
        return device === 'desktop' ? '-5px' : '-5px'
      default:
        return null
    }
  }

  switch (font.family) {
    case 'AlvaroCondensed':
      return device === 'desktop' ? '3px' : '3px'
    case 'Spartan Extra Light':
      return device === 'desktop' ? '3px' : '1px'
    case 'Canela':
      return device === 'desktop' ? '3px' : '3px'
    case 'WildFire-Regular':
      return device === 'desktop' ? '-16px' : '-12px'
    case 'DarlingRosieSans':
      return device === 'desktop' ? '-4px' : '-4px'
    case 'Charlotte-Southern':
      return device === 'desktop' ? '10px' : '5px'
    case 'Spartan-Regular':
      return device === 'desktop' ? '2px' : '2px'
    case 'Beautynigella-Regular':
      return device === 'desktop' ? '-4px' : '-4px'
    case 'Signatie':
      return device === 'desktop' ? '6px' : '6px'
    case 'Sacramento-Regular':
      return device === 'desktop' ? '4px' : '4px'
    case 'Xilosa':
      return device === 'desktop' ? '4px' : '4px'
    case 'Alice':
      return device === 'desktop' ? '-2px' : '-2px'
    case 'LovileType':
      return device === 'desktop' ? '-5px' : '-5px'
    case 'P22ZanerOne':
      return device === 'desktop' ? '4px' : '4px'
    default:
      return null
  }
}

export default textPosition
